import {
  aSuppressList,
  aSuppressListPage,
  mockSuppressedListEditorOperationQuery,
  mockSuppressedListOperationQuery,
  mockSuppressedListSelectOperationQuery,
  mockSuppressedListsOperationQuery,
  SuppressList,
} from '__generated__';

export const getMockSuppressedListOperationQuery_create = (
  suppressList: Partial<SuppressList>
) => {
  return mockSuppressedListOperationQuery((_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Query',
        suppressList: aSuppressList({
          ...suppressList,
        }),
      })
    );
  });
};

export const handlers = [
  mockSuppressedListEditorOperationQuery((_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Query',
        suppressList: aSuppressList(),
      })
    );
  }),
  mockSuppressedListOperationQuery((_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Query',
        suppressList: aSuppressList(),
      })
    );
  }),
  mockSuppressedListsOperationQuery((_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Query',
        suppressLists: aSuppressListPage(),
        suppressListItemLimit: 10000,
        suppressListItemCount: aSuppressListPage().total,
      })
    );
  }),
  mockSuppressedListSelectOperationQuery((_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Query',
        suppressLists: aSuppressListPage(),
      })
    );
  }),
];
